import { render, staticRenderFns } from "./paiements.vue?vue&type=template&id=ebfeacba&"
import script from "./paiements.vue?vue&type=script&lang=js&"
export * from "./paiements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports